/**
 * Initial tracked routes data for first-time app setup.
 * Empty by default - users can import demo tracks via the UI if desired.
 */
const initialActivitiesData = [];

export default initialActivitiesData;
